/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

// Define response models based on the API structure
export interface EpisodeOfCareDto {
  episodeOfCareId: number;
  patientId: number;
  condition: string;
  startedOn: string;
  endedOn: string | null;
}

export interface PatientDto {
  patientId: number;
  firstName: string;
  lastName: string;
  middleName: string | null;
  suffix: string | null;
  phone: string | null;
  email: string | null;
  address: string | null;
  postalCode: string | null;
  medicalHistory: string | null;
  episodesOfCare: EpisodeOfCareDto[];
  createdUtc: string;
  modifiedUtc: string;
  deletedUtc: string | null;
  dateOfBirth: string | null;
}

export interface PractitionerDto {
  practitionerId: number;
  firstName: string;
  lastName: string;
  suffix: string | null;
  phone: string | null;
  email: string | null;
  address: string | null;
  postalCode: string | null;
  medicalCredentials: string | null;
  createdUtc: string;
  modifiedUtc: string;
  deletedUtc: string | null;
}

export interface ClinicAppointmentDto {
  clinicAppointmentId: number;
  patientId: number;
  practitionerId: number;
  episodeOfCareId: number;
  scheduledOn: string;
  duration: number;
  status: string;
  occurredOn: string | null;
  notes: string | null;
  patient: PatientDto;
  practitioner: PractitionerDto;
}

export interface ClinicAppointmentDtoListBaseResponse {
  succeeded: boolean;
  message: string | null;
  errors: string[] | null;
  data: ClinicAppointmentDto[];
}

export interface ClinicAppointmentDtoBaseResponse {
  succeeded: boolean;
  message: string | null;
  errors: string[] | null;
  data: ClinicAppointmentDto;
}

@Injectable({
  providedIn: 'root',
})
export class ClinicAppointmentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiClinicappointmentsGet
   */
  static readonly ApiClinicappointmentsGetPath = '/api/clinicappointments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicappointmentsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicappointmentsGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<ClinicAppointmentDtoListBaseResponse>> {
        const rb = new RequestBuilder(this.rootUrl, ClinicAppointmentService.ApiClinicappointmentsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClinicAppointmentDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), use `apiClinicappointmentsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicappointmentsGet$Json(params?: {
  }): Observable<ClinicAppointmentDtoListBaseResponse> {
    return this.apiClinicappointmentsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClinicAppointmentDtoListBaseResponse>) => {
        return r.body as ClinicAppointmentDtoListBaseResponse;
      })
    );
  }

  /**
   * Path part for operation apiClinicappointmentsPost
   */
  static readonly ApiClinicappointmentsPostPath = '/api/clinicappointments/patient/{patientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicappointmentsPost$Json()` instead.
   */
  apiClinicappointmentsPost$Json$Response(params: {
    patientId: number;
    body: ClinicAppointmentDto
  }): Observable<StrictHttpResponse<ClinicAppointmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicAppointmentService.ApiClinicappointmentsPostPath, 'post');
    if (params) {
      rb.path('patientId', params.patientId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClinicAppointmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), use `apiClinicappointmentsPost$Json$Response()` instead.
   */
  apiClinicappointmentsPost$Json(params: {
    patientId: number;
    body: ClinicAppointmentDto
  }): Observable<ClinicAppointmentDtoBaseResponse> {
    return this.apiClinicappointmentsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClinicAppointmentDtoBaseResponse>) => r.body as ClinicAppointmentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiClinicappointmentsIdGet
   */
  static readonly ApiClinicappointmentsIdGetPath = '/api/clinicappointments/{id}';
  
  // Using the global API configuration from the app module

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicappointmentsIdGet$Json()` instead.
   */
  apiClinicappointmentsIdGet$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ClinicAppointmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicAppointmentService.ApiClinicappointmentsIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClinicAppointmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), use `apiClinicappointmentsIdGet$Json$Response()` instead.
   */
  apiClinicappointmentsIdGet$Json(params: {
    id: number;
  }): Observable<ClinicAppointmentDtoBaseResponse> {
    return this.apiClinicappointmentsIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClinicAppointmentDtoBaseResponse>) => r.body as ClinicAppointmentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiClinicappointmentsIdPut
   */
  static readonly ApiClinicappointmentsIdPutPath = '/api/clinicappointments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicappointmentsIdPut$Json()` instead.
   */
  apiClinicappointmentsIdPut$Json$Response(params: {
    id: number;
    body: ClinicAppointmentDto
  }): Observable<StrictHttpResponse<ClinicAppointmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicAppointmentService.ApiClinicappointmentsIdPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClinicAppointmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), use `apiClinicappointmentsIdPut$Json$Response()` instead.
   */
  apiClinicappointmentsIdPut$Json(params: {
    id: number;
    body: ClinicAppointmentDto
  }): Observable<ClinicAppointmentDtoBaseResponse> {
    return this.apiClinicappointmentsIdPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClinicAppointmentDtoBaseResponse>) => r.body as ClinicAppointmentDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiClinicappointmentsIdDelete
   */
  static readonly ApiClinicappointmentsIdDeletePath = '/api/clinicappointments/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicappointmentsIdDelete$Json()` instead.
   */
  apiClinicappointmentsIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ClinicAppointmentDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicAppointmentService.ApiClinicappointmentsIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClinicAppointmentDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), use `apiClinicappointmentsIdDelete$Json$Response()` instead.
   */
  apiClinicappointmentsIdDelete$Json(params: {
    id: number;
  }): Observable<ClinicAppointmentDtoBaseResponse> {
    return this.apiClinicappointmentsIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClinicAppointmentDtoBaseResponse>) => r.body as ClinicAppointmentDtoBaseResponse)
    );
  }

  /**
   * Log DNA for an appointment
   */
  logDna(id: number, reason: string) {
    const url = `${this.rootUrl}/api/clinicappointments/${id}/dnalog`;
    return this.http.post(url, { reason });
  }
}
